export default __webpack_public_path__ + "static/media/thumbnail.00f5182d.png";